module.exports = __webpack_public_path__ + "trademark5.png?35c59312393b057843e8da20575558c4";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark5.png
// module id = 505
// module chunks = 0